import { AnimatePresence, motion } from "framer-motion";
import { FC } from "react";

import { Alert, AlertProps, Box } from "@theme/components";

export interface ToastContainerProps {
  toasts: AlertProps[];
}

export const ToastContainer: FC<ToastContainerProps> = ({ toasts }) => {
  const container = {
    hidden: {
      opacity: 0,
    },
    show: {
      opacity: 1,
      transition: {
        delayChildren: 0.5,
        staggerDirection: 1,
      },
    },
  };

  const itemVariants = {
    hidden: {
      opacity: 0,
      x: 100,
      transition: {
        type: "spring",
        bounce: 0.1,
      },
    },
    show: {
      opacity: 1,
      x: 0,
      transition: {
        type: "spring",
        bounce: 0.1,
      },
    },
  };

  return (
    <Box
      aria-live="polite"
      sx={{
        position: "fixed",
        top: [64, null, 134],
        right: 20,
        width: "full",
        maxWidth: 300,
        zIndex: 999999999,
      }}
    >
      <AnimatePresence>
        <motion.div variants={container} initial="hidden" animate="show" exit="hidden">
          {toasts.map((toast: AlertProps) => {
            return (
              <motion.div
                key={toast.id}
                role="status"
                variants={itemVariants}
                initial="hidden"
                animate="show"
                exit="hidden"
                sx={{ my: "s100" }}
              >
                <Alert location="toast" {...toast} />
              </motion.div>
            );
          })}
        </motion.div>
      </AnimatePresence>
    </Box>
  );
};
